import React, { Component } from 'react';
import $ from 'jquery';
import Titulo from '../comum/Titulo';
import {
    getAdminEmpresa,
    getGestorEmpresa,
    getOperadorEmpresa,
    PERFIL_ADMIN,
} from '../../security/securityContext';
import { formatCPF, formatTelefone, formatPontos } from '../../util/numberUtil';
import Autorizacao from '../../security/Autorizacao';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import buscarClientesPorEmpresa from '../../actions/adesao-pontos/buscarClientesEmpresa';
import { reduxForm } from 'redux-form';
import ModalEditarClientePontos from './ModalEditarClientePontos';
import ModalViagensClientePontos from './ModalViagensClientePontos';
import ModalTrocarPontosCliente from './ModalTrocarPontosCliente';
import ModalDetalhamentoFinanceiroCliente from './ModalDetalhamentoFinanceiroCliente';

export const CabecalhoTabela = () => null;

export class PainelGerenciarClientesEmpresa extends Component {
    constructor(props) {
        super(props);
        this.state = { clienteSelecionado: null };
    }

    componentDidMount() {
        this.props.buscarClientesPorEmpresa(this.props.empresaSelecionada.id);
    }

    abrirModal(modalId, cliente) {
        this.setState({ clienteSelecionado: cliente }, () => {
            $(`#${modalId}`).modal('show');
        });
    }

    exibirListaClientes() {
        const { listaClientes } = this.props;

        if (listaClientes && listaClientes.length) {
            return (
                <div className="vx-table-scroll">
                    <table className="vx-table-left">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Nome</th>
                                <th>CPF</th>
                                <th>E-mail</th>
                                <th>Telefone</th>
                                <th>Pts Disponíveis</th>
                                <th>Pts Congelados</th>
                                <th>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {listaClientes.map(cliente => (
                                <tr key={`lista-clientes-${cliente.id}`}>
                                    <td style={{ color: '#aaa', fontSize: 12 }}>{cliente.id}</td>
                                    <td style={{ fontWeight: 600 }}>{cliente.nome}</td>
                                    <td>{formatCPF(cliente.cpf)}</td>
                                    <td>{cliente.email || <span style={{ color: '#ccc' }}>—</span>}</td>
                                    <td>{formatTelefone(cliente.telefone)}</td>
                                    <td>
                                        <span className="vx-pts-badge vx-pts-badge--green">
                                            <i className="material-icons" style={{ fontSize: 12 }}>star</i>
                                            {formatPontos(cliente.pontosDisponiveis)}
                                        </span>
                                    </td>
                                    <td>
                                        <span className="vx-pts-badge vx-pts-badge--red">
                                            <i className="material-icons" style={{ fontSize: 12 }}>lock</i>
                                            {formatPontos(cliente.pontosCongelados)}
                                        </span>
                                    </td>
                                    <td>
                                        <div className="dropdown">
                                            <button
                                                className="vx-actions-trigger"
                                                type="button"
                                                data-toggle="dropdown"
                                                aria-haspopup="true"
                                                aria-expanded="false">
                                                <i className="material-icons">more_vert</i>
                                            </button>
                                            <div className="dropdown-menu dropdown-menu-right vx-actions-menu">
                                                <button type="button" className="dropdown-item vx-action-item"
                                                    onClick={() => this.abrirModal('modalEditarClientePontos', cliente)}>
                                                    <i className="material-icons">edit</i> Editar dados
                                                </button>
                                                <button type="button" className="dropdown-item vx-action-item"
                                                    onClick={() => this.abrirModal('modalViagensClientePontos', cliente)}>
                                                    <i className="material-icons">list_alt</i> Viagens
                                                </button>
                                                <button type="button" className="dropdown-item vx-action-item"
                                                    onClick={() => this.abrirModal('modalTrocarPontosCliente', cliente)}>
                                                    <i className="material-icons">swap_horiz</i> Ajustar pontos
                                                </button>
                                                <div className="dropdown-divider" />
                                                <button type="button" className="dropdown-item vx-action-item"
                                                    onClick={() => this.abrirModal('modalDetalhamentoFinanceiroCliente', cliente)}>
                                                    <i className="material-icons">account_balance_wallet</i> Extrato financeiro
                                                </button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            );
        }

        return (
            <div className="vx-empty-state">
                <i className="material-icons">people</i>
                <p>Nenhum cliente encontrado para esta empresa.</p>
            </div>
        );
    }

    render() {
        const { clienteSelecionado } = this.state;

        return (
            <Autorizacao perfisPermitidos={[
                PERFIL_ADMIN,
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getGestorEmpresa(this.props.empresaSelecionada.id),
            ]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div className="container-padrao">
                    <Titulo texto="Clientes — Programa de Pontos" urlRetorno="/menu-adesao-pontos-empresa" />
                    <div className="vx-table-card">
                        {this.exibirListaClientes()}
                    </div>
                </div>

                <ModalEditarClientePontos
                    cliente={clienteSelecionado}
                    onSalvar={() => this.props.buscarClientesPorEmpresa(this.props.empresaSelecionada.id)}
                />
                <ModalViagensClientePontos cliente={clienteSelecionado} />
                <ModalTrocarPontosCliente cliente={clienteSelecionado} />
                <ModalDetalhamentoFinanceiroCliente cliente={clienteSelecionado} />
            </Autorizacao>
        );
    }
}

export function mapStateToProps(state) {
    return {
        listaClientes: state.buscarClientesEmpresa || [],
        authentication: state.authentication,
        empresaSelecionada: state.empresaSelecionada,
    };
}

export default withRouter(connect(mapStateToProps, {
    buscarClientesPorEmpresa,
})(reduxForm({
    form: 'formularioPainelGerenciarClientesEmpresa',
})(PainelGerenciarClientesEmpresa)));
